/**
 * Roles
 * 1	"Administrador"
 */
//  img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg',

let details = navigator.userAgent;
let regexp = /android|iphone|kindle|ipad/i;
let isMobileDevice = regexp.test(details);

export const MenuHandler = {
  1: [
    {
      heading: " ",
      translate: "sidebar.heading.HEADER",
    },
    {
      name: "dashboard",
      icon: "demo-icon  icon-10abr23-iconosmagicdome-01_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_tablero-de-control.svg',
      path: "/dashboard",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "shipments",
      icon: "demo-icon icon-10abr23-iconosmagicdome-06_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg',
      path: "/trazabilidad",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "Warehousing",
      icon: "icon-warehouse-solid-2",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg',
      path: "/warehousing",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "finance",
      icon: "demo-icon icon-10abr23-iconosmagicdome-10_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_facturacion-y-costos.svg',
      path: "/finanzas",
      translate: "sidebar.nav.DASHBOARD",
    },

    !isMobileDevice
      ? {
          name: "report_analytics",
          icon: "demo-icon icon-10abr23-iconosmagicdome-09_",
          // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_reportes.svg',

          translate: "sidebar.nav.DASHBOARD",
          submenu: [
            {
              name: "my_reports",
              path: "/reports",
            },
            {
              name: "OBL analytics",
              path: "/obl-analytics",
            },
          ],
        }
      : {
          name: "report_analytics",
          icon: "demo-icon icon-10abr23-iconosmagicdome-09_",
          // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_reportes.svg',

          translate: "sidebar.nav.DASHBOARD",
          path: "/reports",
        },
    {
      name: "documents",
      icon: "demo-icon icon-folder-empty",
      path: "/documents",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "logistic_tools",
      icon: "demo-icon icon-10abr23-iconosmagicdome-12_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_herramientas-logisticas.svg',
      path: "/tools",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "admin",
      icon: "demo-icon icon-final-19",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_administracion.svg',
      // path: "/admin",
      // translate: 'sidebar.nav.DASHBOARD',
      submenu: [
        {
          name: "alert_notification",
          path: "/alerts-and-notifications",
        },
        {
          name: "users",
          path: "/admin",
        },
      ],
    },
    {
      name: "Service Desk",
      icon: "far fa-question-circle",
      path: "/service-desk",
      translate: "sidebar.nav.DASHBOARD",
    },
  ],
  2: [
    {
      heading: " ",
      translate: "sidebar.heading.HEADER",
    },
    {
      name: "dashboard",
      icon: "demo-icon  icon-10abr23-iconosmagicdome-01_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_tablero-de-control.svg',
      path: "/dashboard",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "shipments",
      icon: "demo-icon icon-10abr23-iconosmagicdome-06_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg',
      path: "/trazabilidad",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "Warehousing",
      icon: "icon-warehouse-solid-2",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg',
      path: "/warehousing",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "finance",
      icon: "demo-icon icon-10abr23-iconosmagicdome-10_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_facturacion-y-costos.svg',
      path: "/finanzas",
      translate: "sidebar.nav.DASHBOARD",
    },

    !isMobileDevice
      ? {
          name: "report_analytics",
          icon: "demo-icon icon-10abr23-iconosmagicdome-09_",
          // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_reportes.svg',

          translate: "sidebar.nav.DASHBOARD",
          submenu: [
            {
              name: "my_reports",
              path: "/reports",
            },
            {
              name: "OBL analytics",
              path: "/obl-analytics",
            },
          ],
        }
      : {
          name: "report_analytics",
          icon: "demo-icon icon-10abr23-iconosmagicdome-09_",
          // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_reportes.svg',

          translate: "sidebar.nav.DASHBOARD",
          path: "/reports",
        },
    {
      name: "documents",
      icon: "demo-icon icon-folder-empty",
      path: "/documents",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "logistic_tools",
      icon: "demo-icon icon-10abr23-iconosmagicdome-12_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_herramientas-logisticas.svg',
      path: "/tools",
      translate: "sidebar.nav.DASHBOARD",
    },
  ],
  3: [
    {
      heading: " ",
      translate: "sidebar.heading.HEADER",
    },
    {
      name: "dashboard",
      icon: "demo-icon  icon-10abr23-iconosmagicdome-01_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_tablero-de-control.svg',
      path: "/dashboard",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "shipments",
      icon: "demo-icon icon-10abr23-iconosmagicdome-06_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg',
      path: "/trazabilidad",
      translate: "sidebar.nav.DASHBOARD",
    },
    // {
    //   name: "Warehousing",
    //   icon: "icon-warehouse-solid-2",
    //   // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg',
    //   path: "/warehousing",
    //   translate: "sidebar.nav.DASHBOARD",
    // },
    // {
    //   name: "finance",
    //   icon: "demo-icon icon-10abr23-iconosmagicdome-10_",
    //   // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_facturacion-y-costos.svg',
    //   path: "/finanzas",
    //   translate: "sidebar.nav.DASHBOARD",
    // },
    {
      name: "report_analytics",
      icon: "demo-icon icon-10abr23-iconosmagicdome-09_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_reportes.svg',

      translate: "sidebar.nav.DASHBOARD",
      submenu: [
        {
          name: "my_reports",
          path: "/reports",
        },
        {
          name: "OBL analytics",
          path: "/obl-analytics",
        },
      ],
    },
    // {
    //   name: "report_analytics",
    //   icon: "demo-icon icon-10abr23-iconosmagicdome-09_",
    //   // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_reportes.svg',

    //   translate: "sidebar.nav.DASHBOARD",
    //   path: "/reports",
    // },
    {
      name: "documents",
      icon: "demo-icon icon-folder-empty",
      path: "/documents",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "logistic_tools",
      icon: "demo-icon icon-10abr23-iconosmagicdome-12_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_herramientas-logisticas.svg',
      path: "/tools",
      translate: "sidebar.nav.DASHBOARD",
    },
  ],
  4: [
    {
      heading: " ",
      translate: "sidebar.heading.HEADER",
    },
    {
      name: "dashboard",
      icon: "demo-icon  icon-10abr23-iconosmagicdome-01_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_tablero-de-control.svg',
      path: "/dashboard",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "shipments",
      icon: "demo-icon icon-10abr23-iconosmagicdome-06_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg',
      path: "/trazabilidad",
      translate: "sidebar.nav.DASHBOARD",
    },
    /*     {
      name: "Warehousing",
      icon: "icon-warehouse-solid-2",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_trazabilidad-de-embarques.svg',
      path: "/warehousing",
      translate: "sidebar.nav.DASHBOARD",
    }, */
    {
      name: "finance",
      icon: "demo-icon icon-10abr23-iconosmagicdome-10_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_facturacion-y-costos.svg',
      path: "/finanzas",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "report_analytics",
      icon: "demo-icon icon-10abr23-iconosmagicdome-09_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_reportes.svg',

      translate: "sidebar.nav.DASHBOARD",
      submenu: [
        {
          name: "my_reports",
          path: "/reports",
        },
        {
          name: "OBL analytics",
          path: "/obl-analytics",
        },
      ],
    },
    {
      name: "documents",
      icon: "demo-icon icon-folder-empty",
      path: "/documents",
      translate: "sidebar.nav.DASHBOARD",
    },
    {
      name: "logistic_tools",
      icon: "demo-icon icon-10abr23-iconosmagicdome-12_",
      // img: 'https://magiclog.blob.core.windows.net/europartnerspic/Icono_herramientas-logisticas.svg',
      path: "/tools",
      translate: "sidebar.nav.DASHBOARD",
    },
  ],
};
